<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  .contact-information {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: utils.in_rem(16px);

    .contact-information-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .contact-information-title {
        display: flex;
        font-size: 1rem;
        font-weight: 700;
        line-height: 1.5rem;
        justify-content: center;
      }
    }

    .contact-information-enrichment-text {
      @include mixins.body2();
      @include colors.color(systemInformation_100);
    }

    .contact-information-list {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
  }
</style>

<script>
  // Stores
  import {
    activePopUpModalStore,
    candidateApiStore,
    candidatePhoneStore,
    candidateStore,
    todosModalItemStore,
  } from "../stores";
  import { flaggedContacts } from "./stores";
  // Components
  import InlineNotification from "@sourcewhale/shared/svelte-design-system/components/atoms/InlineNotification.svelte";
  import SelectorLabel from "@sourcewhale/shared/svelte-design-system/components/atoms/SelectorLabel.svelte";
  import EnrichButton from "./EnrichButton.svelte";
  import NoContactInfo from "./NoContactInfo.svelte";

  let enrichmentText = "";

  let noData;
  let noEmails;
  let noPhones;

  const flagClick = (contactToFlag) => {
    activePopUpModalStore.set({
      modal: "flagContact",
      contactToFlag,
    });
  };

  const { meta } = candidateApiStore; // meta is not in candidateStore

  // Filtering of flagged phones is already done in candidatePhoneStore definition
  // so we only need to filter emails here
  $: filteredEmails = ($candidateStore?.emails || []).filter(
    (email) => !$flaggedContacts.includes(email.trim())
  );

  $: {
    noEmails = filteredEmails.length === 0;
    noPhones = Object.keys($candidatePhoneStore || {}).length === 0;
    noData = noEmails && noPhones;
  }
</script>

<div class="contact-information" class:skeleton={$meta.fetching}>
  <div class="contact-information-header">
    <div class="contact-information-title">Contact Information</div>
    <EnrichButton bind:enrichmentText />
  </div>
  {#if enrichmentText}
    <div class="contact-information-enrichment-text">
      {enrichmentText}
    </div>
  {/if}
  {#if $meta.firstFetchDone && !$meta.fetching && $candidateStore.isDeleted}
    <InlineNotification message="error">
      This contact has been deleted from SourceWhale.
    </InlineNotification>
  {:else if $meta.firstFetchDone && !$meta.fetching && noData}
    <NoContactInfo />
  {:else}
    <div class="contact-information-list">
      {#if $meta.fetching || !$meta.firstFetchDone}
        {#each Array(3) as _}
          <SelectorLabel
            skeleton={true}
            label="loading contact information..."
            kind="email"
          />
        {/each}
      {:else}
        {#if noEmails}
          <SelectorLabel label="No emails" kind="email" missing={true} />
        {:else}
          {#each filteredEmails as email}
            <SelectorLabel
              label={email}
              kind="email"
              flagClick={() => flagClick(email)}
              bounce={Array.isArray($todosModalItemStore?.bouncedEmailSet) &&
                $todosModalItemStore.bouncedEmailSet.includes(email)}
            />
          {/each}
        {/if}
        {#if noPhones}
          <SelectorLabel label="No phone" kind="landline" missing={true} />
        {:else}
          {#each $candidatePhoneStore as phone}
            <!-- TODO: format mobile phone numbers with +44 instead of 0 -->
            <SelectorLabel
              label={phone.phone}
              kind={phone.kind}
              flagClick={() => flagClick(phone.phone)}
            />
          {/each}
        {/if}
      {/if}
    </div>
  {/if}
</div>
